import { createContext, useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const RetailerAuthContext = createContext(null);

export function RetailerAuthProvider({ children }) {
  const [retailer, setRetailer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
  try {
    const res = await fetch(`${API_BASE}/api/retailer/auth/me`, {
      credentials: 'include',
    });
    const data = await res.json();

    if (res.ok) {
      setRetailer(data.retailer);
    } else {
      setRetailer(null);
    }
  } catch (error) {
    setRetailer(null);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    refresh();
  }, []);

  const logout = async () => {
    try {
      await fetch(`${API_BASE}/api/retailer/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });
    } finally {
      setRetailer(null);
    }
  };

  return (
    <RetailerAuthContext.Provider value={{ retailer, loading, setRetailer, logout, refresh }}>
      {children}
    </RetailerAuthContext.Provider>
  );
}

export function useRetailerAuth() {
  const ctx = useContext(RetailerAuthContext);
  if (!ctx) throw new Error('useRetailerAuth must be used inside RetailerAuthProvider');
  return ctx;
}

export function RetailerProtectedRoute({ children }) {
  const { retailer, loading } = useRetailerAuth();
  if (loading) return null;
  if (!retailer) return <Navigate to="/retailer/login" replace />;
  return children;
}